<!--
 Program: UserListPopup.vue
 Author: SDL
 Description: A pop-up screen that queries the user's information and sends the selected user's information.
-->
<template>
  <div class="modal-dialog">
    <div class="modal_content">
      <!-- contents -->
      <div class="modal_header">
        <h5>
          {{ $t('sdl.approval.label.requiredApprovalUser') }} {{ $t('sdl.common.label.search') }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')" />
      </div>
      <div class="modal_body">
        <div class="list_wrap">
          <div class="scop_grid h_auto">
          <!-- TABLE Area-->
            <table>
              <colgroup>
                <col width="50px"/>
                <col />
                <col />
                <col />
                <col />
                <col v-if="cspInfo.show"/>
                <col v-if="divisionShow"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">
                    <input type="checkbox" @click.stop v-model="selectAll" @change="toggleSelectAll" />
                  </th>
                  <th scope="col">{{ $t('sdl.user.label.knoxId') }}</th>
                  <th scope="col">{{ $t('sdl.common.label.name') }}</th>
                  <th scope="col">{{ $t('sdl.user.label.deptName') }}</th>
                  <th scope="col">{{ $t('sdl.user.label.mobile') }}</th>
                  <th scope="col" v-if="cspInfo.show">CSP in charge</th>
                  <th scope="col" v-if="divisionShow">Division</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in userList" :key="user.userId">
                  <td class="text-center">
                    <input type="checkbox" v-model="user.selected" @change="selectRow(user)" />
                  </td>
                  <td class="text-left" :title="user.user.knoxId">{{ user.user.knoxId }}</td>
                  <td class="text-left" :title="locale === 'ko_KR' ? user.user.userName : user.user.userNameEn">{{ locale === 'ko_KR' ? user.user.userName : user.user.userNameEn }}</td>
                  <td class="text-left" :title="locale === 'ko_KR' ? user.user.deptName : user.user.deptNameEn">{{ locale === 'ko_KR' ? user.user.deptName : user.user.deptNameEn }}</td>
                  <td class="text-left" :title="user.user.mobile">{{ user.user.mobile }}</td>
                  <td class="text-left" :title="user.cspCodes" v-if="cspInfo.show">{{ user.cspCodes }}</td>
                  <td class="text-left" :title="user.divisionCd" v-if="divisionShow">{{ getDivisionLabel(user.divisionCd) }}</td>
                </tr>
                <tr v-show="userList.length === 0">
                  <td :colspan="cspInfo.show ? (divisionShow ? 7 : 6) : 5">{{ $t('sdl.common.message.noResult') }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- TABLE Area-->
      </div>
      <div class="modal_footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('sdl.common.label.cancel') }}
        </button>
        <button type="button" class="btn btn-primary" @click="rtnData">{{ $t('sdl.common.label.confirm') }}</button>
      </div>
      <!-- // contents -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { SDLUtil } from '@/utils';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
      selectAll: false,
      per_page: null,
      current_page: null,
      total: null,
      cspInfo: { show: false, data: {}},
      userList: [],
      selectUser: [],
      checkUserId: '',
    };
  },
  props: {
    docType: {
      required: false,
      type: String,
    },
    rtnFunc: {
      type: Function,
    },
    divisionCd: {
      type: String,
      default: '',
    },
    approvalReqType: {
      type: String,
      default: '',
    },
    chgPrjDivObj: {
      type: Object,
      default: () => {},
    }
  },
  methods: {
    /**
     * param: object
     * return: nothing
     * exception: nothing
     * description: User Lookup List Checkbox Click
     */
    selectRow(item) {
      if (!item.selected && this.selectAll) {
        this.selectAll = false;
      }
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: Select All
     */
    toggleSelectAll() {
      this.userList.forEach(user => {
        user.selected = this.selectAll;
      });
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: setCspInfo
     */
    setCspInfo() {
      let isShow = false;
      SDLUtil.getCommCodeList({ commCodeTypeId: 'APPR_TYP_4_DIV_ADMIN' }).some(item => {
        isShow = this.docType === item.code;
        return isShow;
      });

      let data = {};
      if (isShow) {
        SDLUtil.getCommCodeList({ commCodeTypeId: 'STD_CSP_CD' }).forEach(item => {
          data[item.codeId] = item.code;
        });
      };

      this.cspInfo = {show : isShow, data : data};
    },
    /**
     * param:
     * return: nothing
     * exception: Call error alert
     * description: getRequiredApprovalList
     */
    getRequiredApprovalList(divisionCd) {
      // Loading bar execution
      SDLUtil.showLoadingBar(true);
      axios
        .get(`${SDLUtil.API_URL}/scop-approval/required-approval-users/${this.docType}?divisionCd=${divisionCd}`)
        .then(response => {

          response.data.forEach(userInfo => {
            if (userInfo.employeeStatus !== 'B') return;

            let cspCodes = [];
            if (this.cspInfo.show && userInfo.cspCodeIds) {
              userInfo.cspCodeIds.forEach(cspCodeId => {
                cspCodes.push(this.cspInfo.data[cspCodeId]);
              });
            };
            userInfo.cspCodes = cspCodes.join(", ");
            userInfo.divisionCd = divisionCd;

            this.userList.push(userInfo);
          });

          // Loading bar hidden
          SDLUtil.showLoadingBar(false);
        })
        .catch(error => {
          SDLUtil.showLoadingBar(false);
          console.log(error);
        });
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: Calling up functions that send selected user information to the screen from which it was recalled
     */
    rtnData() {
      let selectUser = [];

      /**
       * Apply outgoing values by branching out if they are applied on a quarterly basis
       */
      selectUser = this.userList.filter(user => user.selected);

      this.rtnFunc(selectUser);
      this.$emit('close');
    },
    /**
     * 프로젝트 사업부 변경 결재 시 이전 사업부/이관 사업부 필수 결재자 조회
    */
    getChgPrjDivRequiredApprovalList() {
      let divisionCdList = [this.chgPrjDivObj.currentDivisionCd, this.chgPrjDivObj.changeDivisionCd];
      divisionCdList.forEach( divisionCd => {
        this.getRequiredApprovalList(divisionCd);
      })
    },
    getDivisionLabel(divisionCd) {
      const division = _.find(this.divisionInfo, { divisionCd: divisionCd });
      return division.label;
    },
  },
  created() {
    this.setCspInfo();
    if (this.approvalReqType === 'chgPrjDiv' || (this.approvalReqType === 'movAcc' && this.chgPrjDivObj.currentDivisionCd !== this.chgPrjDivObj.changeDivisionCd)) {
      this.getChgPrjDivRequiredApprovalList();
    } else {
      this.getRequiredApprovalList(this.divisionCd);
    }
  },
  computed: {
    ...mapGetters({ locale: 'getLocale', divisionInfo: 'getDivisionInfo' }),
    divisionShow() {
      return (this.approvalReqType === 'chgPrjDiv' ||
        (this.approvalReqType === 'movAcc' && this.chgPrjDivObj.currentDivisionCd !== this.chgPrjDivObj.changeDivisionCd));
    }
  },

};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/view/admin/approval/popup/RequiredApprListPopup.vue